module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfhCQ4FKBMjK1paAAAAZ0lEQVQ4y2NgGAXEgCKGTwz/ccLTDJJIajUYtjHgVf6f4T9DEVSxIMNEht8M/xkIKP/P0MDAwMDCkMPwBsJnIcrZFxm0YEwmojRoIZjEaWAYfBqukapBnyGX4S2MQ3LEkZw0RgFhAAAJc15yjb/dpgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxNy0wOS0xNFQwNTo0MDoxOSswMjowMMy5NsEAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTctMDktMTRUMDU6NDA6MTkrMDI6MDC95I59AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/minivideo2.png
// module id = 94
// module chunks = 0